module.exports = __webpack_public_path__ + "media/feedback-2-65dc040f9f79c5c583dd12db9da3f856.png";